import { Grid } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { IsCustomMaxWidth } from 'core/util/WindowSize';
import { fetchStorageFile } from 'hooks/StoreFiles';
import GridColumns from 'pages/ebooks/components/templates/GridColumns';
import ResponsiveGrid from 'pages/ebooks/components/templates/ResponsiveGrid';
import React from 'react';
import styled from 'styled-components';

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        background-color: #eae8e6;
        font-family: 'Barlow', sans-serif;
        padding-bottom: 80px;
        padding-top: 80px;
    `,

    Content: styled.div`
        display: flex;
        flex-direction: column;
        gap: 1rem;
    `,

    Card: styled.div`
        background-color: white;
        padding: 20px;
        border-radius: 20px;

        p {
            font-size: 18px;
            line-height: 24px;
        }
    `,
};

interface SessionCIPProps {}

const SessionCIPlanoAnual = ({}: SessionCIPProps) => {

    const is800px = IsCustomMaxWidth(800);

    return (
        <Styled.Container>
            {/* Conteúdo da Sessão CIP */}

            <ResponsiveGrid
                templates={{
                    desktop: '1fr 1fr',
                    notebook: '1fr 1fr',
                    mobile: '1fr',
                }}
            >
                {' '}
                <Styled.Content style={{ alignItems: 'center', padding: is800px ? '0 20px' : '0' }}>
                    <h1
                        dangerouslySetInnerHTML={{
                            __html: `
                        Dados Internacionais de Catalogação na Publicação (CIP) <br/>
                        <b>(BENITEZ Catalogação Ass. Editorial, MS, Brasil)</b>

                        
                        `,
                        }}
                        style={{ textAlign: 'center', lineHeight: '24px', fontSize: '18px' }}
                    />
                    <Styled.Card>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: `
                            C926p <br />
                            1.ed. Paciencia, Luan<br />
                             &nbsp;&nbsp;&nbsp;&nbsp;Plano anual Instituto Ayrton Senna [livro eletrônico] : relatório final 2025 / <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;Luan Paciencia, Gabriela Cáceres. – 1.ed. – São Paulo : Instituto Ayrton Senna, <br />
                            2025. <br />
                            PDF <br /><br />
                            ISBN 978-65-6075-027-2 <br /><br />
                            1. Aprendizagem - Metodologia. 2. Educação pública. 3. Planejamento <br />
                            educacional. 4. Relatórios educacionais. I. Cáceres, Gabriela. II. Título. <br /><br />
                            
                            `,
                            }}
                        />
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p>11-2025/76</p>
                            <p>CDD 370</p>
                        </div>
                    </Styled.Card>
                    <h1
                        dangerouslySetInnerHTML={{
                            __html: `
                               <b> Índice para catálogo sistemático: </b><br />
                            1. Planejamento e relatórios educacionais : Educação pública 370<br />
                             <b>Aline Graziele Benitez – Bibliotecária - CRB-1/3129 </b>
                        `,
                        }}
                        style={{ textAlign: 'center', lineHeight: '24px', fontSize: '18px' }}
                    />
                    <img
                        width={'140px'}
                        src={fetchStorageFile('anexo_storage_files_7874924120477492769.svg_2025-11-18-1763497332225.svg')}
                        alt=""
                    />
                </Styled.Content>
                <Styled.Content>
                    <img
                        style={{ borderRadius: '20px', objectFit: 'cover' }}
                        width={'100%'}
                        height={'500px'}
                        src={fetchStorageFile('anexo_storage_files_4189689327820385151.webp_2025-11-18-1763497702154.webp')}
                        alt=""
                    />
                </Styled.Content>
            </ResponsiveGrid>
        </Styled.Container>
    );
};

export default SessionCIPlanoAnual;
